import React, { FC } from 'react';
import styles from './index.module.scss';
import { keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import CustomTooltip from '@/pages/IndustrialGreenMicBigScreen/components/CustomTooltip';

interface IDataBox {
  top: number;
  left: number;
  leftTitle: string;
  data: { label: string; value?: number | string; unit?: string; color?: string }[];
}

const DataBox: FC<IDataBox> = props => {
  const { top, left, leftTitle, data } = props;
  return (
    <div className={styles.yuan_box} style={{ top: `${top}%`, left: `${left}%` }}>
      <div className={styles.left_top_bg}>{leftTitle}</div>
      {data.map((item, index) => (
        <div key={index} className={styles[`line${index}`]}>
          <div className={styles.label}>{item.label}</div>
          <CustomTooltip title={`${item.value}${item.unit}`}>
            <div className={styles.value} style={{ color: item.color }}>
              {item.value}
              {item.unit}
            </div>
          </CustomTooltip>
        </div>
      ))}
    </div>
  );
};

export default DataBox;
